const state = {
  snackbar: {
    visible: false,
    text: null,
    timeout: 4000,
    multiline: false,
    status: '',
    icon: '',
    color: ''
  }
};

const getters = {
  snackbar: state => state.snackbar
}

const mutations = {
  SHOW_SNACKBAR: (state, payload) => {
    state.snackbar.text = payload.text;
    state.snackbar.status = payload.status;
    state.snackbar.icon = payload.status === 'success' ? 'mdi-check' : 'mdi-alert';
    state.snackbar.color = payload.status;
    state.snackbar.multiline = (payload.text.length > 50) ? true : false;

    if (payload.multiline) {
      state.snackbar.multiline = payload.multiline;
    }

    if (payload.timeout) {
      state.snackbar.timeout = payload.timeout;
    }

    state.snackbar.visible = true;
  },

  CLOSE_SNACKBAR: state => {
    state.snackbar.visible = false;
    state.snackbar.text = null;
    state.snackbar.timeout = 3000;
    state.snackbar.multiline = false;
  }
};

export default {
  state,
  getters,
  mutations
}